import type { GetAssessmentStatsResponse } from '@libs/types';
import { useQuery } from '@tanstack/react-query';

import { apiClient } from '@api';

import { queryKeys } from '../../../constants/query-keys';

/**
 * Tenant-scoped assessment counts for the dashboard stat strip
 * (total / completed / processing / drafts).
 */
async function getAssessmentStats(
  signal?: AbortSignal,
): Promise<GetAssessmentStatsResponse> {
  const response = await apiClient.get<GetAssessmentStatsResponse>(
    'api/assessments/stats',
    { signal },
  );
  return response.data;
}

export const useAssessmentStats = () =>
  useQuery<GetAssessmentStatsResponse>({
    queryKey: queryKeys.assessments.stats,
    queryFn: ({ signal }) => getAssessmentStats(signal),
    staleTime: 0,
    refetchOnMount: 'always',
  });
